module.exports = __webpack_public_path__ + "img/mobilehardware4.1da9e481.png";